import { Box, CircularProgress } from '@material-ui/core';
import React, { useState } from 'react';
import styled from 'styled-components/macro';

const PreviewBodyHtmlLinkIframe = ({ ticketId, bodyHtmlLink }) => {
  const [isLoadingIframe, setIsLoadingIframe] = useState(true);
  return (
    <SBodyHtmlWrapper>
      {isLoadingIframe && (
        <Box marginTop="1rem">
          <CircularProgress size="25px" color="primary" />
        </Box>
      )}
      {bodyHtmlLink && (
        <iframe
          title={ticketId}
          src={bodyHtmlLink}
          width="100%"
          height="100%"
          frameBorder={0}
          allowFullScreen
          style={{
            border: 0,
            overflow: 'hidden',
          }}
          onLoad={() => setIsLoadingIframe(false)}
        ></iframe>
      )}
    </SBodyHtmlWrapper>
  );
};

export default PreviewBodyHtmlLinkIframe;
const SBodyHtmlWrapper = styled.div`
  padding: 0 1rem;
  flex: 1;
  overflow: hidden;
`;
